import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material'
import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

export interface ICheckBoxOptions {
  label: string
  value: string
}

interface Sizing {
  xs: number
  sm: number
  md: number
  lg: number
  xl: number
}

interface IFormRadio {
  name: string
  control: any
  sizing: Sizing
  options: ICheckBoxOptions[]
}

const FormRadio: React.FC<IFormRadio> = ({ sizing, name, control, options }) => {
  return (
    <Grid item xs={sizing.xs} sm={sizing.sm} md={sizing.md} lg={sizing.lg} xl={sizing.xl}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup {...field}>
            {options.map((option, index) => (
              <FormControlLabel
                key={index}
                value={option.value}
                control={
                  <Radio
                    icon={<RadioButtonUnchecked sx={{ opacity: 0.6 }} />}
                    checkedIcon={<RadioButtonChecked color='primary' />}
                  />
                }
                label={option.label}
              />
            ))}
          </RadioGroup>
        )}
      />
    </Grid>
  )
}

export default FormRadio
